import { movieListAPI, options } from "./constants";
import { useEffect, useState } from "react";

const fetchMovies = (page = 1) => {
  const [movies, setMovies] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const getMovies = async () => {
      setLoading(true);
      const response = await fetch(movieListAPI + page, options);
      const responseInJson = await response.json();
      setMovies(responseInJson?.results);
      setLoading(false);
    };

    getMovies();
  }, [page]);

  return { movies, loading };
};

export { fetchMovies };
